import { Link } from 'react-router';
import { useDocumentTitle } from '../lib/useDocumentTitle.js';

export default function NotFound() {
  useDocumentTitle('Page Not Found');
  return (
    <div className="container" style={{ paddingTop: '4rem', paddingBottom: '4rem' }}>
      <h1>Page not found</h1>
      <p>There&rsquo;s nothing at this address.</p>
      <p>
        <Link to="/">Back to the homepage</Link>
      </p>
    </div>
  );
}
